module.exports = __webpack_public_path__ + "img/vue.9cf6e1ef.png";